import React from 'react'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'

interface CloseButtonProps {
  onClick: () => void
  className?: string
}

const StyledCloseButton = styled.button`
  position: absolute;
  right: 4%;
  top: 2vh;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  font-size: inherit;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.red};
  color: ${({ theme }) => theme.colors.white};
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.5);
  align-items: center;
  transition: 0.2s;
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.2), 0 4px 20px 0 rgba(0, 0, 0, 0.2);

  svg {
    width: 45%;
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.white};

    svg {
      width: 100%;
      height: 100%;
      color: ${({ theme }) => theme.colors.black};
      fill: ${({ theme }) => theme.colors.black};
    }
  }

  &.fade-in {
    animation: fade-in-x50 0.5s ease forwards;
  }

  &.fade-out {
    animation: fade-out-x50 0.5s ease forwards;
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.xxs}) {
    width: 50px;
    height: 50px;
  }

  @media (min-height: ${({ theme }) => theme.breakpoints.deviceH.xs}) {
    top: 10vh;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xs}) and (min-height: ${({
      theme,
    }) => theme.breakpoints.deviceH.sm}) {
    top: 18vh;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.sm}) {
    width: 70px;
    height: 70px;
    top: 10.5vh;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.md}) {
    width: 80px;
    height: 80px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xl}) {
    width: 90px;
    height: 90px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.deviceW.xxl}) {
    width: 112px;
    height: 112px;
    top: 15vh;
  }
`

const CloseButton: React.FC<CloseButtonProps> = ({ onClick, className }) => {
  return (
    <StyledCloseButton onClick={onClick} className={className}>
      <SVG src="/icons/x.svg" />
    </StyledCloseButton>
  )
}

export default CloseButton
